import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { RequestsService } from '../lib/requests.service'

const REQUESTS_QUICK_FILTERS = 'requests-quick-filters'

export const useRequestQuickFilters = () => {
  const { selectedProjectId } = useSelectedProjectStore()

  return useQuery({
    queryKey: [REQUESTS_QUICK_FILTERS, selectedProjectId],
    queryFn: () => RequestsService.getRequestQuickFilters(selectedProjectId),
    select: response => response.data
  })
}
